<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="thresholdColor"
      entity-name="threshold_color"
      :icon="'mdi-heart'"
      :model="model"
    >
      <template #footer>
        <v-btn
          class="red ml-2"
          @click="reset"
        >
          {{ $t('reset_product_threshold') }}
        </v-btn>
      </template>
    </ik-data-table>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import DThresholdColorSetting from '@/model/dataLayer/api/restaurant/DThresholdColorSetting'

export default {

  components: {
    IkDataTable
  },
  data: function () {
    return ({
      model: DThresholdColorSetting
    })
  },
  methods: {
    async reset () {
      await this.model.resetColorList()
      this.$refs.thresholdColor.reload()
    }
  }
}
</script>

<style scoped>

</style>
